const AUTO_REFRESH_INTERVAL_MS = 60000;

export {
  AUTO_REFRESH_INTERVAL_MS
}
